import React from 'react'

const Profession = () => {
  return (
    <div className=' md:mt-[88px] max-w-containerSm md:max-w-container mx-auto'>
        <p className='text-[24px] font-medium text-[#010101]'>Şirkətimizin Heyəti</p>
        <div className='grid grid-cols-1 md:grid-cols-4 mt-6 gap-5'>
     <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Kərimov Ramin</p>
   <p className='text-[16px] font-normal text-[#010101]'>Direktor</p>
     </div>
       <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Əhmədov Rövşən</p>
   <p className='text-[16px] font-normal text-[#010101]'>Baş menecer</p>
     </div>
       <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Məmmədova Gülnar</p>
   <p className='text-[16px] font-normal text-[#010101]'>Aparıcı mühasib</p>
     </div>
       <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Bəxtiyarlı İlkin Elxan</p>
   <p className='text-[16px] font-normal text-[#010101]'>Satınalma üzrə mütəxəssis</p>
     </div>
         <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Sədullayeva Aydan</p>
   <p className='text-[16px] font-normal text-[#010101]'>İnşaat mühəndisi</p>
     </div>
      <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Cəbiyev Nicat</p>
   <p className='text-[16px] font-normal text-[#010101]'>İnşaat mühəndisi</p>
     </div>
        <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Əhmədova Vüsalə</p>
   <p className='text-[16px] font-normal text-[#010101]'>Ofis meneceri</p>
     </div>
      <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>İskəndərov Surac</p>
   <p className='text-[16px] font-normal text-[#010101]'>Texniki ofis mühəndisi</p>
     </div>
      <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Savalanov Elvin</p>
   <p className='text-[16px] font-normal text-[#010101]'>Topoqraf</p>
     </div>
      <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Abaszadə İsmayıl</p>
   <p className='text-[16px] font-normal text-[#010101]'>Smeta mühəndisi</p>
     </div>
       <div className='px-5 py-4 bg-[white] rounded-[8px] border-l-4 border-[#2A3D63]'>
   <p className='text-[18px] font-medium text-[#010101]'>Abduləliyev Zaur</p>
   <p className='text-[16px] font-normal text-[#010101]'>Sahə mühəndisi</p>
     </div>
        </div>
        </div>
  )
}

export default Profession